<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="role !== null">

    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.data_scopes') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
          <button [withRight]="editRight" *ngIf="loading !== true && loadError !== true" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div *ngIf="loadError === true" role="alert" class="p-messages p-component p-mb-4">
      <div role="alert" class="p-message p-message-error">
        <div class="p-message-wrapper">
          <span class="p-message-icon pi pi-times-circle" aria-hidden="true"></span>
          <span class="p-message-detail">{{ t('common.messages.load_error') }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="loadError !== true && isFullAccess()" role="alert" class="p-messages p-component p-mb-4">
      <div role="alert" class="p-message p-message-warn">
        <div class="p-message-wrapper">
          <span class="p-message-icon pi pi-exclamation-triangle" aria-hidden="true"></span>
          <span class="p-message-detail">{{ t('common.messages.full_data_access') }}</span>
        </div>
      </div>
    </div>

    <app-loader [loading]="loading"></app-loader>

    <div class="p-grid p-fluid" *ngIf="loading !== true && loadError !== true">
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'data_scopes'" [control]="form.get('data_scopes')" [type]="'multiselect'" [label]="t('common.labels.data_scopes')" [edit]="inEdit" [basevalue]="getScopeNames()" [options]="scopes" [optionLabel]="'option_title'" [dataKey]="'id'" [showClear]="true"></app-form-control>
      </div>
      <div class="p-col-12" *ngIf="isFullAccess() !== true && getEffectiveRestrictionLabel() !== ''">
        {{ t('common.labels.effective_restriction') }}: {{ getEffectiveRestrictionLabel() }}
      </div>
    </div>

  </form>
</ng-container>
